// @flow
import React from 'react';
import PassengerSeat from './passenger-seat.js';
import { getDefaultSeats } from '../weight-and-balance.helpers';

class PassengerSeats extends React.Component {
  constructor(props: Props) {
    super(props);

    this.handleDrop = this.handleDrop.bind(this);
  }

  handleDrop(event, row, col) {
    const { onMove } = this.props;

    event.preventDefault();

    const a = {
      row: Number(event.dataTransfer.getData('row')),
      col: Number(event.dataTransfer.getData('col'))
    };

    const b = {
      row,
      col
    };

    onMove(a, b);
  }

  render() {
    const { seats, passengers, isPilotRight, onAdd, onEdit, onRemove } = this.props;

    return (
      <div className="passenger-seats">
        {seats.map((row, r) => (
          <div key={r}>
            <div className="seats-row-title">{row.name}:</div>
            <div className="d-flex flex-wrap">
              {row.seats > 0 ? (
                getDefaultSeats(row.seats).map((_, index) => {
                  const type = r === 0 && index === 0 ? "pilot" : "passenger";

                  return (
                    <PassengerSeat
                      isPilotRight={isPilotRight}
                      key={`${r}-${index}`}
                      row={r}
                      col={index}
                      data={passengers && passengers[r] && passengers[r][index]}
                      type={type}
                      onAdd={onAdd}
                      onEdit={onEdit}
                      onRemove={onRemove}
                      onDrop={this.handleDrop}
                    />
                  )})
              ) : (
                <div className="seats-empty-row">Row without seats</div>
              )}
            </div>
          </div>
        ))}
      </div>
    );
  }
}

export default PassengerSeats;
